const isDashboardGadget = (
  card: CanvasCard.Card,
): card is CanvasCard.DashboardGadgetCard =>
  card.content.type === 'Dashboard Gadget';

export default isDashboardGadget;
